// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.LandingPage_main__KrAyt {
  min-height: 100vh;
  background-color: var(--color-bg);
  color: var(--color-text);
}

/* Section */
.LandingPage_section__7EdB3 {
  padding: 80px 0;
}

.LandingPage_sectionInner__7nR4A {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.LandingPage_textCenter__63XUG {
  text-align: center;
}

/* Section Labels & Titles */
.LandingPage_sectionLabel__JWI4F {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 9999px;
  border: 1px solid rgba(141, 160, 216, 0.3);
  background-color: rgba(141, 160, 216, 0.1);
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-accent);
  margin-bottom: 16px;
}

.LandingPage_sectionTitle__BTXaA {
  font-size: 36px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
}

.LandingPage_sectionSubtitle__1Gwu0 {
  font-size: 18px;
  color: var(--color-text-muted);
  margin-top: 16px;
}

/* Separator */
.LandingPage_separator__zCjgL {
  height: 1px;
  background-color: var(--color-border);
  opacity: 0.4;
  max-width: 1200px;
  margin: 0 auto;
}

/* Hero Section */
.LandingPage_heroSection__ZO0qF {
  padding-top: 120px;
  position: relative;
  overflow: hidden;
}

.LandingPage_workflowSection__0kf\\+j {
  padding: 96px 0 72px;
  background: var(--color-bg);
  position: relative;
  overflow: hidden;
}

.LandingPage_workflowGlow__UmV0- {
  position: absolute;
  top: -220px;
  right: 12%;
  width: 520px;
  height: 520px;
  background: var(--color-accent);
  opacity: 0.08;
  filter: blur(140px);
  border-radius: 50%;
  pointer-events: none;
}

.LandingPage_workflowInner__EoJhq {
  max-width: 1150px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
  z-index: 1;
}

.LandingPage_workflowHeader__KvKxc {
  text-align: center;
}

.LandingPage_workflowPill__S32SR {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.LandingPage_workflowTitle__5E-9F {
  margin-top: 16px;
  font-size: 32px;
  font-weight: 600;
  color: var(--color-text-strong);
  letter-spacing: -0.02em;
}

.LandingPage_workflowQuestion__gsa\\+D {
  margin-top: 14px;
  font-size: 18px;
  color: var(--color-text);
}

.LandingPage_workflowBody__zBYNP {
  margin: 16px auto 0;
  max-width: 780px;
  font-size: 15px;
  line-height: 1.7;
  color: var(--color-text-muted);
}

.LandingPage_workflowGrid__cL3CM {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  align-items: stretch;
}

.LandingPage_workflowPreviewCard__L08TU {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  backdrop-filter: blur(18px);
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.35);
}

.LandingPage_workflowPreviewPills__lWwAS {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.LandingPage_workflowPreviewPill__km4Ed {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  font-size: 12px;
  color: var(--color-text-muted);
}

.LandingPage_workflowTileGrid__2vwyf {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.LandingPage_workflowTile__9QWNK {
  padding: 14px;
  border-radius: 16px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  color: var(--color-text-muted);
  font-size: 13px;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.LandingPage_workflowBottomRow__etBIq {
  padding: 14px;
  border-radius: 16px;
  border: 1px dashed var(--color-border);
  background: var(--color-bg-muted);
  text-align: center;
  font-size: 13px;
  color: var(--color-text-muted);
}

.LandingPage_workflowCardStack__B1vUg {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.LandingPage_workflowCard__\\+mt2E {
  border-radius: 24px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  padding: 22px;
  backdrop-filter: blur(18px);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.LandingPage_workflowCard__\\+mt2E:hover {
  transform: translateY(-2px);
  border-color: rgba(141, 160, 216, 0.4);
}

.LandingPage_workflowCardHeader__pnNpG {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.LandingPage_workflowCardTitle__fI05x {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-strong);
}

.LandingPage_workflowCardTagline__GG84F {
  margin-top: 6px;
  font-size: 14px;
  color: var(--color-text);
}

.LandingPage_workflowCardBody__OgZo\\+ {
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

.LandingPage_workflowCardIcon__wiWGD {
  color: var(--color-text-muted);
}


.LandingPage_workflowPreviewImages__F12wr {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 32px auto;
}

.LandingPage_workflowPreviewImage__mlwhk {
  flex: 1 1;
  max-width: 48%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .LandingPage_workflowPreviewImages__F12wr {
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
  }
  
  .LandingPage_workflowPreviewImage__mlwhk {
    flex: none;
    width: 100%;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
}

.LandingPage_workflowValueLine__V1cxs {
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  color: var(--color-text);
}

.LandingPage_workflowCta__LBk5T {
  align-self: center;
  padding: 14px 32px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  color: var(--color-text-strong);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease, border-color 0.3s ease, transform 0.3s ease;
}

.LandingPage_workflowCta__LBk5T:hover {
  background: var(--color-bg-muted);
  border-color: rgba(141, 160, 216, 0.4);
  transform: translateY(-1px);
}

.LandingPage_workflowCta__LBk5T:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent), 0 0 0 4px var(--color-bg);
}

@media (min-width: 1024px) {
  .LandingPage_workflowGrid__cL3CM {
    grid-template-columns: 1.1fr 1fr;
  }

  .LandingPage_workflowPreviewCard__L08TU {
    position: sticky;
    top: 120px;
    align-self: flex-start;
  }
}

@media (max-width: 640px) {
  .LandingPage_workflowSection__0kf\\+j {
    padding: 64px 0 56px;
  }

  .LandingPage_workflowTitle__5E-9F {
    font-size: 28px;
  }

  .LandingPage_workflowQuestion__gsa\\+D {
    font-size: 16px;
  }

  .LandingPage_workflowValueLine__V1cxs {
    font-size: 18px;
  }
}

.LandingPage_heroGlow__8iwyK {
  position: absolute;
  top: -300px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 600px;
  background: var(--color-accent);
  opacity: 0.1;
  filter: blur(120px);
  border-radius: 50%;
  pointer-events: none;
}

.LandingPage_heroContent__VWhWs {
  text-align: center;
  position: relative;
  z-index: 1;
}

.LandingPage_heroIntro__muOyO {
  margin-top: 18px;
}

.LandingPage_heroIntroTitle__9UFAn {
  font-size: 14px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.LandingPage_heroIntroSubtitle__p4k\\+x {
  margin-top: 10px;
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-strong);
}

.LandingPage_heroIntroBody__FmnKE {
  margin: 14px auto 0;
  max-width: 760px;
  font-size: 16px;
  line-height: 1.7;
  color: var(--color-text-muted);
}

.LandingPage_heroTitle__gyAP8 {
  font-size: 48px;
  font-weight: 700;
  max-width: 800px;
  margin: 24px auto 0;
  background: linear-gradient(90deg, var(--color-text), var(--color-accent), var(--color-text));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (min-width: 768px) {
  .LandingPage_heroTitle__gyAP8 {
    font-size: 64px;
  }
}

@media (min-width: 1024px) {
  .LandingPage_heroTitle__gyAP8 {
    font-size: 72px;
  }
}

.LandingPage_heroSubtitle__I8NWM {
  font-size: 18px;
  color: var(--color-text-muted);
  max-width: 640px;
  margin: 24px auto 0;
}

.LandingPage_heroCta__TT1OT {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 40px;
}

@media (min-width: 640px) {
  .LandingPage_heroCta__TT1OT {
    flex-direction: row;
  }
}

.LandingPage_heroDisclaimer__ixQsQ {
  font-size: 14px;
  color: var(--color-text-muted);
  margin-top: 24px;
}

.LandingPage_heroPreview__sBXk5 {
  max-width: 800px;
  margin: 64px auto 0;
}

/* CTA Buttons */
.LandingPage_ctaPrimary__ENXMi {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  border-radius: 8px;
  border: none;
  background-color: var(--color-accent);
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.LandingPage_ctaPrimary__ENXMi:hover {
  opacity: 0.9;
}

.LandingPage_ctaSecondary__kZFdA {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background-color: transparent;
  color: var(--color-text);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.LandingPage_ctaSecondary__kZFdA:hover {
  background-color: var(--color-bg-muted);
}

/* Mock Chart */
.LandingPage_mockChart__r\\+kaR {
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 4px;
}

.LandingPage_heroPreviewImage__wY6\\+j {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}


.LandingPage_mockChartInner__4TEV5 {
  position: relative;
  height: 320px;
  border-radius: 12px;
  background-color: var(--color-bg-muted);
  overflow: hidden;
}

.LandingPage_mockChartGrid__-qfZV {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(to right, var(--color-border) 1px, transparent 1px),
    linear-gradient(to bottom, var(--color-border) 1px, transparent 1px);
  background-size: 32px 32px;
  opacity: 0.3;
}

.LandingPage_mockChartBadges__fuQtu {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  gap: 8px;
}

.LandingPage_mockChartBadge__VEevW {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 9999px;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg-muted);
  font-size: 12px;
  color: var(--color-text-muted);
}

.LandingPage_mockChartBadgeLive__TrpaZ {
  color: var(--color-success);
}

.LandingPage_mockChartLines__tZBlP {
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 80px;
  height: 128px;
}

.LandingPage_mockChartArea__Xnqbp {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 96px;
  background: linear-gradient(to top, rgba(141, 160, 216, 0.2), transparent);
  border-radius: 8px;
}

.LandingPage_mockChartLine1__dWV39 {
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: var(--color-accent);
}

.LandingPage_mockChartLine2__5dONP {
  position: absolute;
  bottom: 64px;
  left: 25%;
  right: 25%;
  height: 1px;
  background-color: var(--color-success);
}

.LandingPage_mockChartFooter__93kTh {
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--color-text-muted);
}

/* Benefits Grid */
.LandingPage_benefitsGrid__HsHhG {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 48px;
}

@media (min-width: 768px) {
  .LandingPage_benefitsGrid__HsHhG {
    grid-template-columns: repeat(3, 1fr);
  }
}

.LandingPage_benefitCard__zKXRm {
  padding: 24px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  transition: all 0.2s;
}

.LandingPage_benefitCard__zKXRm:hover {
  border-color: rgba(141, 160, 216, 0.5);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.LandingPage_benefitIcon__MUhin {
  display: inline-flex;
  padding: 12px;
  border-radius: 12px;
  background-color: rgba(141, 160, 216, 0.1);
  color: var(--color-accent);
  margin-bottom: 16px;
}

.LandingPage_benefitTitle__POFUx {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px;
}

.LandingPage_benefitDesc__uDkF7 {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
}

/* Services */
.LandingPage_servicesGrid__uP6jM {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: center;
}

@media (min-width: 768px) {
  .LandingPage_servicesGrid__uP6jM {
    grid-template-columns: 1fr 1fr;
  }
}

.LandingPage_servicesList__pBzWO {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.LandingPage_serviceItem__cqQp3 {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 12px;
}

.LandingPage_serviceIcon__96G3V {
  padding: 8px;
  border-radius: 8px;
  background-color: rgba(141, 160, 216, 0.1);
  color: var(--color-accent);
}

.LandingPage_serviceTitle__8Utat {
  font-weight: 600;
  color: var(--color-text);
}

.LandingPage_serviceDesc__UXWQo {
  font-size: 14px;
  color: var(--color-text-muted);
}

.LandingPage_servicesPanel__MrMNx {
  padding: 24px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
}

.LandingPage_servicesPanelBadges__BCEkS {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.LandingPage_badge__a\\+OTk {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 9999px;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg-muted);
  font-size: 12px;
  color: var(--color-text-muted);
}

.LandingPage_badgeSuccess__BTMxW {
  color: var(--color-success);
}

.LandingPage_servicesPanelContent__NOHNQ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.LandingPage_servicesPanelCard__uToh2 {
  padding: 16px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 12px;
}

.LandingPage_servicesPanelLabel__mcsXf {
  font-size: 12px;
  color: var(--color-text-muted);
  margin-bottom: 8px;
}

.LandingPage_servicesPanelTags__XGEK2 {
  display: flex;
  gap: 8px;
}

.LandingPage_servicesPanelBar__8MkI5 {
  margin-top: 12px;
  height: 80px;
  border-radius: 8px;
  background-color: var(--color-bg);
}

.LandingPage_servicesPanelBarFill__wJhpt {
  height: 100%;
  width: 66%;
  border-radius: 8px;
  background: linear-gradient(to right, rgba(141, 160, 216, 0.3), transparent);
}

.LandingPage_servicesPanelHeatmap__MjP4X {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
}

.LandingPage_heatmapCell__\\+rZgF {
  height: 32px;
  border-radius: 4px;
}

.LandingPage_heatmapSuccess__DPR20 {
  background-color: rgba(0, 204, 0, 0.4);
}

.LandingPage_heatmapWarning__hb\\+sY {
  background-color: rgba(246, 196, 83, 0.4);
}

.LandingPage_heatmapAccent__OanK\\+ {
  background-color: rgba(141, 160, 216, 0.2);
}

/* Features Grid */
.LandingPage_featuresGrid__x7864 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 48px;
}

@media (min-width: 640px) {
  .LandingPage_featuresGrid__x7864 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .LandingPage_featuresGrid__x7864 {
    grid-template-columns: repeat(3, 1fr);
  }
}

.LandingPage_featureCard__sEUkv {
  padding: 20px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  transition: background-color 0.2s;
}

.LandingPage_featureCard__sEUkv:hover {
  background-color: var(--color-bg-panel);
}

.LandingPage_featureIcon__YCB0K {
  display: inline-flex;
  padding: 8px;
  border-radius: 8px;
  background-color: rgba(141, 160, 216, 0.1);
  color: var(--color-accent);
  margin-bottom: 12px;
}

.LandingPage_featureTitle__VhAB5 {
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 4px;
}

.LandingPage_featureDesc__yfNPQ {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
}

/* Process */
.LandingPage_processGrid__PXMvy {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-top: 48px;
}

@media (min-width: 768px) {
  .LandingPage_processGrid__PXMvy {
    grid-template-columns: 1fr 1.5fr;
  }
}

.LandingPage_processSteps__C0Jzh {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.LandingPage_processStep__LpHN4 {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: none;
  background-color: var(--color-bg-muted);
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  color: var(--color-text);
}

.LandingPage_processStep__LpHN4:hover {
  background-color: var(--color-bg-panel);
}

.LandingPage_processStepActive__KYGQW {
  background-color: var(--color-accent);
  color: white;
}

.LandingPage_processStepActive__KYGQW:hover {
  background-color: var(--color-accent);
}

.LandingPage_processStepNumber__yq09W {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.7;
}

.LandingPage_processStepTitle__vY4l6 {
  font-weight: 600;
  margin-top: 4px;
}

.LandingPage_processDetail__90e7D {
  padding: 32px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
}

.LandingPage_processDetailNumber__lciCa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--color-accent);
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
}

.LandingPage_processDetailTitle__lYOGW {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px;
}

.LandingPage_processDetailDesc__ioKqI {
  color: var(--color-text-muted);
  margin: 0;
}

.LandingPage_processDetailVisual__N40Xx {
  margin-top: 24px;
  height: 160px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--color-accent) 0%, transparent 50%);
  opacity: 0.2;
}

/* Testimonials */
.LandingPage_testimonialsGrid__wSQrU {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 48px;
}

@media (min-width: 768px) {
  .LandingPage_testimonialsGrid__wSQrU {
    grid-template-columns: repeat(3, 1fr);
  }
}

.LandingPage_testimonialCard__L08wi {
  padding: 24px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
}

.LandingPage_testimonialStars__5O6gX {
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
}

.LandingPage_testimonialQuote__A3k-6 {
  color: var(--color-text-muted);
  margin: 0 0 16px;
}

.LandingPage_testimonialAuthor__zLi9m {
  display: flex;
  align-items: center;
  gap: 12px;
}

.LandingPage_testimonialAvatar__jnfWF {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(141, 160, 216, 0.2);
}

.LandingPage_testimonialName__3iZAe {
  font-weight: 600;
  color: var(--color-text);
}

.LandingPage_testimonialRole__fhpHC {
  font-size: 12px;
  color: var(--color-text-muted);
}

/* Pricing */
.LandingPage_pricingToggle__ZBleh {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.LandingPage_pricingToggle__ZBleh > div {
  display: inline-flex;
  padding: 4px;
  border-radius: 9999px;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg-muted);
}

.LandingPage_toggleButton__DkFrm {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 9999px;
  border: none;
  background-color: transparent;
  color: var(--color-text-muted);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.LandingPage_toggleButtonActive__Wp0PI {
  background-color: var(--color-accent);
  color: white;
}

.LandingPage_toggleBadge__nTlSI {
  padding: 2px 8px;
  border-radius: 9999px;
  background-color: rgba(0, 204, 0, 0.2);
  font-size: 12px;
  color: var(--color-success);
}

.LandingPage_pricingGrid__t\\+VWu {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 48px;
}

@media (min-width: 768px) {
  .LandingPage_pricingGrid__t\\+VWu {
    grid-template-columns: repeat(3, 1fr);
  }
}

.LandingPage_pricingCard__p5bXf {
  position: relative;
  padding: 24px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
}

.LandingPage_pricingCardPopular__CZCOg {
  border-color: var(--color-accent);
  box-shadow: 0 10px 40px rgba(141, 160, 216, 0.2);
}

.LandingPage_pricingBadge__rQfQh {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: var(--color-accent);
  color: white;
  font-size: 12px;
  font-weight: 500;
}

.LandingPage_pricingName__n5FiT {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 16px;
}

.LandingPage_pricingPrice__ceBk4 {
  margin-bottom: 24px;
}

.LandingPage_pricingAmount__PooEI {
  font-size: 36px;
  font-weight: 700;
  color: var(--color-text);
}

.LandingPage_pricingPeriod__iuw2m {
  color: var(--color-text-muted);
}

.LandingPage_pricingButton__PriaE {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  background-color: var(--color-bg-muted);
  color: var(--color-text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.LandingPage_pricingButton__PriaE:hover {
  background-color: var(--color-bg);
}

.LandingPage_pricingButtonPopular__a1Tpi {
  background-color: var(--color-accent);
  color: white;
}

.LandingPage_pricingButtonPopular__a1Tpi:hover {
  opacity: 0.9;
  background-color: var(--color-accent);
}

.LandingPage_pricingFeatures__2SZrz {
  list-style: none;
  padding: 0;
  margin: 24px 0 0;
}

.LandingPage_pricingFeature__6ixvX {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--color-text-muted);
  margin-bottom: 12px;
}

/* Comparison */
.LandingPage_comparisonTable__FGSD1 {
  max-width: 768px;
  margin: 48px auto 0;
}

.LandingPage_comparisonHeader__Pp20z {
  display: grid;
  grid-template-columns: 1fr 100px 100px;
  gap: 16px;
  margin-bottom: 12px;
}

.LandingPage_comparisonUs__ZP31z {
  text-align: center;
  font-weight: 600;
  color: var(--color-accent);
}

.LandingPage_comparisonOthers__Tzs6U {
  text-align: center;
  font-weight: 600;
  color: var(--color-text-muted);
}

.LandingPage_comparisonRow__vvabe {
  display: grid;
  grid-template-columns: 1fr 100px 100px;
  gap: 16px;
  padding: 16px;
  margin-bottom: 12px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 8px;
}

.LandingPage_comparisonFeature__ZngBp {
  font-size: 14px;
  color: var(--color-text);
}

.LandingPage_comparisonCheck__rPltY,
.LandingPage_comparisonX__sQWMt {
  display: flex;
  justify-content: center;
}

/* FAQ */
.LandingPage_faqGrid__FfnnH {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
}

@media (min-width: 768px) {
  .LandingPage_faqGrid__FfnnH {
    grid-template-columns: 1fr 1fr;
  }
}

.LandingPage_faqContact__6XtUR {
  margin-top: 32px;
  padding: 24px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
}

.LandingPage_faqContactTitle__LPjFT {
  font-weight: 600;
  color: var(--color-text);
}

.LandingPage_faqContactText__dfd4t {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 8px 0 16px;
}

.LandingPage_faqList__AeVTx {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.LandingPage_faqItem__VcGCV {
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  overflow: hidden;
}

.LandingPage_faqQuestion__Y2TX7 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: none;
  background-color: transparent;
  color: var(--color-text);
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.LandingPage_faqChevronOpen__YxBmc {
  transform: rotate(90deg);
}

.LandingPage_faqAnswer__NDNMU {
  padding: 0 16px 16px;
  font-size: 14px;
  color: var(--color-text-muted);
  border-top: 1px solid var(--color-border);
  padding-top: 12px;
}

/* CTA Section */
.LandingPage_ctaSection__042ep {
  padding-bottom: 96px;
}

.LandingPage_ctaCard__Ktc4F {
  position: relative;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  overflow: hidden;
}

.LandingPage_ctaCardGlow__nt2hV {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(141, 160, 216, 0.1), transparent, rgba(141, 160, 216, 0.1));
  pointer-events: none;
}

.LandingPage_ctaCardContent__CAu5W {
  position: relative;
  padding: 48px;
  text-align: center;
}

.LandingPage_ctaCardLabel__UFR3j {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
}

.LandingPage_ctaCardTitle__P2B59 {
  font-size: 32px;
  font-weight: 700;
  color: var(--color-text);
  margin: 16px 0 0;
}

@media (min-width: 768px) {
  .LandingPage_ctaCardTitle__P2B59 {
    font-size: 40px;
  }
}

.LandingPage_ctaCardSubtitle__2LDJW {
  color: var(--color-text-muted);
  max-width: 512px;
  margin: 16px auto 0;
}

.LandingPage_ctaCardButtons__e2jZ6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
}

@media (min-width: 640px) {
  .LandingPage_ctaCardButtons__e2jZ6 {
    flex-direction: row;
  }
}

.LandingPage_ctaCardDisclaimer__8wz3A {
  font-size: 12px;
  color: var(--color-text-muted);
  margin: 24px 0 0;
}

/* Footer */
.LandingPage_footer__WdWFd {
  padding: 32px 0;
  border-top: 1px solid var(--color-border);
}

/* Removed conflicting footerInner - using the one below */

.LandingPage_footerLinks__9S\\+Pb {
  display: flex;
  gap: 24px;
}

.LandingPage_footerLinks__9S\\+Pb a {
  color: var(--color-text-muted);
  text-decoration: none;
  transition: color 0.2s;
}

.LandingPage_footerLinks__9S\\+Pb a:hover {
  color: var(--color-text);
}

/* Optimized layout additions */
.LandingPage_heroSupport__t3IsX {
  font-size: 16px;
  color: var(--color-text-muted);
  max-width: 680px;
  margin: 16px auto 0;
}

.LandingPage_heroSecondaryCta__zhXvX {
  margin-top: 12px;
}

.LandingPage_socialProof__4wAIN {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  padding: 16px 24px 0;
  color: var(--color-text-muted);
  font-size: 0.85rem;
}

.LandingPage_socialProofItem__GSIev {
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
}

.LandingPage_navCardGrid__Frp69 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  margin-top: 24px;
}

.LandingPage_navCardGroup__Dtpbh {
  margin-top: 28px;
}

.LandingPage_navGroupLabel__-eJyl {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-text-muted);
  margin-bottom: 10px;
}

.LandingPage_navCard__Yztjk {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 14px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.LandingPage_navCardHighlight__XaK7c {
  border-color: rgba(141, 160, 216, 0.5);
  box-shadow: 0 0 0 1px rgba(141, 160, 216, 0.2);
}

.LandingPage_navCardTitle__l20\\+m {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text);
}

.LandingPage_navCardDesc__Tu35R {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  line-height: 1.4;
}

.LandingPage_navCardAction__b\\+wy5 {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  color: var(--color-accent);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.LandingPage_navCardAction__b\\+wy5:hover {
  opacity: 0.85;
}

.LandingPage_bulletList__mW\\+5Y {
  list-style: none;
  padding: 0;
  max-width: 720px;
  margin: 24px auto 0;
  display: grid;
  gap: 12px;
  color: var(--color-text);
}

.LandingPage_bulletList__mW\\+5Y li {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 0.95rem;
}

.LandingPage_featureGrid__ZE1RR {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
  align-items: center;
}

.LandingPage_featureGridReverse__Qtl8\\+ {
  direction: rtl;
}

.LandingPage_featureGridReverse__Qtl8\\+ > * {
  direction: ltr;
}

.LandingPage_featureList__Q8Sh-,
.LandingPage_trustList__Ey0f5 {
  list-style: none;
  padding: 0;
  display: grid;
  gap: 10px;
  margin-top: 16px;
  color: var(--color-text);
}

.LandingPage_trustList__Ey0f5 li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.LandingPage_mockPanel__-RTbL {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 14px;
  padding: 20px;
}

.LandingPage_mockTabs__-QIEz {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.LandingPage_mockTab__FPMyi,
.LandingPage_mockTabActive__TpCjm {
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.75rem;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
}

.LandingPage_mockTabActive__TpCjm {
  color: var(--color-accent);
  background: rgba(141, 160, 216, 0.15);
}

.LandingPage_mockRow__9qkDH {
  margin-bottom: 16px;
}

.LandingPage_mockLabel__AoTGl {
  font-size: 0.75rem;
  color: var(--color-text-muted);
  margin-bottom: 8px;
}

.LandingPage_mockLine__EmUr0 {
  height: 120px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(141, 160, 216, 0.2), rgba(141, 160, 216, 0.05));
  border: 1px solid var(--color-border);
}

.LandingPage_mockHeatmap__89djB {
  height: 120px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: repeating-linear-gradient(
    90deg,
    rgba(141, 160, 216, 0.15),
    rgba(141, 160, 216, 0.15) 12px,
    rgba(141, 160, 216, 0.05) 12px,
    rgba(141, 160, 216, 0.05) 24px
  );
}

.LandingPage_mockBadgeRow__DYfZ5 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.LandingPage_mockBadge__1BK5t,
.LandingPage_mockBadgeAccent__82thn {
  font-size: 0.7rem;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
}

.LandingPage_mockBadgeAccent__82thn {
  color: var(--color-warning);
  border-color: rgba(246, 196, 83, 0.4);
}

.LandingPage_mockFootnote__aST2p {
  margin-top: 12px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
}

.LandingPage_mockTitle__G5Tjd {
  font-size: 0.85rem;
  color: var(--color-text);
  margin-bottom: 8px;
}

.LandingPage_mockCandles__kG\\+G7 {
  height: 160px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: repeating-linear-gradient(
    90deg,
    rgba(141, 160, 216, 0.18),
    rgba(141, 160, 216, 0.18) 8px,
    transparent 8px,
    transparent 16px
  );
}

.LandingPage_mockOverlayRow__CyljC {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 0.7rem;
  color: var(--color-text-muted);
  margin-top: 10px;
}

.LandingPage_mockRiskBox__E\\+pmr {
  margin-top: 12px;
  height: 60px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: linear-gradient(90deg, rgba(0, 204, 0, 0.2), rgba(255, 107, 107, 0.2));
}

.LandingPage_mockRiskZone__tUG1S {
  height: 100%;
  border-radius: 12px;
}

.LandingPage_macroGrid__Rq5d3 {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  align-items: start;
}

.LandingPage_calloutCard__Yo1aj {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  font-style: italic;
  color: var(--color-text);
}

.LandingPage_confluenceCard__JA3SX {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
}

.LandingPage_confluenceTitle__fxulw {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.LandingPage_confluenceBadges__ZscIh {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.LandingPage_confluenceLines__N7Iao {
  display: grid;
  gap: 6px;
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

.LandingPage_twoColCards__dmAl4 {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

.LandingPage_panelCard__nqlGy {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 20px;
}

.LandingPage_panelCard__nqlGy h3 {
  margin-top: 0;
}

.LandingPage_panelCard__nqlGy ul {
  padding-left: 18px;
  margin: 12px 0 0;
  color: var(--color-text-muted);
}

.LandingPage_complianceCard__H6Fmk {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
}

.LandingPage_complianceCard__H6Fmk ul {
  list-style: none;
  padding: 0;
  margin: 16px auto;
  display: grid;
  gap: 10px;
  justify-content: center;
}

.LandingPage_complianceCard__H6Fmk li {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  color: var(--color-text);
}

.LandingPage_complianceFooter__LY5ZB {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

/* Trade Setups - Hero Stats */

.LandingPage_setupsPreviewContainer__1U58g {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 32px auto;
}

.LandingPage_setupsPreviewImage__sCK1v {
  width: 100%;
  max-width: 1100px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.LandingPage_setupsHeroCta__yhpAx {
  margin-top: 32px;
}

.LandingPage_setupsHeroStats__L\\+bSk {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 24px;
  font-size: 14px;
  color: var(--color-text-muted);
}

.LandingPage_setupsHeroStats__L\\+bSk span {
  display: flex;
  align-items: center;
  gap: 6px;
}

.LandingPage_setupsHeroStats__L\\+bSk span::before {
  content: '✓';
  color: var(--color-success);
}

/* Trade Setups - Benefits */
.LandingPage_setupsBenefits__H3oWt {
  background-color: var(--color-bg-muted);
}

.LandingPage_benefitsGrid__HsHhG {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 48px;
}

@media (max-width: 768px) {
  .LandingPage_benefitsGrid__HsHhG {
    grid-template-columns: 1fr;
  }
}

.LandingPage_benefitCard__zKXRm {
  padding: 32px 24px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  text-align: center;
  transition: all 0.2s;
}

.LandingPage_benefitCard__zKXRm:hover {
  border-color: rgba(141, 160, 216, 0.5);
  transform: translateY(-4px);
}

.LandingPage_benefitIcon__MUhin {
  font-size: 32px;
  margin-bottom: 16px;
}

.LandingPage_benefitTitle__POFUx {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px;
}

.LandingPage_benefitDesc__uDkF7 {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
  line-height: 1.5;
}

/* Trade Setups - Setup Types Grid */
.LandingPage_setupTypesGrid__j\\+jcf {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 48px;
}

@media (max-width: 1024px) {
  .LandingPage_setupTypesGrid__j\\+jcf {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .LandingPage_setupTypesGrid__j\\+jcf {
    grid-template-columns: 1fr;
  }
}

.LandingPage_setupTypeCard__0t503 {
  padding: 20px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  text-align: center;
  transition: all 0.2s;
}

.LandingPage_setupTypeCard__0t503:hover {
  background-color: var(--color-bg-panel);
  border-color: rgba(141, 160, 216, 0.3);
}

.LandingPage_setupTypeIcon__F1pXw {
  font-size: 24px;
  display: block;
  margin-bottom: 12px;
}

.LandingPage_setupTypeCard__0t503 h4 {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 4px;
}

.LandingPage_setupTypeCard__0t503 p {
  font-size: 13px;
  color: var(--color-text-muted);
  margin: 0;
}

/* Trade Setups - Setup Card Demo */
.LandingPage_setupCardDemo__2NgT\\+ {
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 24px;
  font-size: 14px;
}

.LandingPage_setupCardHeader__Z0K0T {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.LandingPage_setupCardDirection__FQfwG {
  font-weight: 600;
  font-size: 16px;
  color: var(--color-text);
}

.LandingPage_setupCardConfidence__7pFsu {
  color: var(--color-success);
  font-weight: 500;
}

.LandingPage_setupCardStatus__KdpF\\+ {
  padding: 4px 10px;
  background-color: rgba(34, 197, 94, 0.15);
  color: var(--color-success);
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
}

.LandingPage_setupCardLevels__0\\+gI5 {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-muted);
}

.LandingPage_setupCardMeta__eOXWV {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--color-text-muted);
  font-size: 13px;
}

.LandingPage_setupCardReason__ClYpg {
  margin-top: 16px;
  padding: 12px;
  background-color: var(--color-bg-muted);
  border-radius: 8px;
}

.LandingPage_setupCardReason__ClYpg strong {
  display: block;
  margin-bottom: 8px;
  color: var(--color-text);
}

.LandingPage_setupCardReason__ClYpg ul {
  margin: 0;
  padding-left: 20px;
  color: var(--color-text-muted);
}

.LandingPage_setupCardReason__ClYpg li {
  margin-bottom: 4px;
}

/* Feature Description */
.LandingPage_featureDesc__yfNPQ {
  color: var(--color-text-muted);
  line-height: 1.6;
  margin-bottom: 24px;
}

.LandingPage_featureDesc__yfNPQ em {
  color: var(--color-accent);
  font-style: normal;
}

/* Overlay List */
.LandingPage_overlayList__vES6N {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.LandingPage_overlayItem__3pDNH {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-size: 13px;
  color: var(--color-text-muted);
}

/* ========================================
   FOOTER
   ======================================== */
.LandingPage_footer__WdWFd {
  background-color: var(--color-bg-panel);
  border-top: 1px solid var(--color-border);
  margin-top: 80px;
}

.LandingPage_footerInner__n\\+pT9 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 64px 24px 32px;
}

/* Footer Top */
.LandingPage_footerTop__reKKL {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 48px;
  padding-bottom: 40px;
  margin-bottom: 0;
}

@media (max-width: 900px) {
  .LandingPage_footerTop__reKKL {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

.LandingPage_footerBrand__qF1Mh {
  max-width: 280px;
}

.LandingPage_footerLogo__yjkRe {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 12px;
}

.LandingPage_footerLogo__yjkRe svg {
  color: var(--color-accent);
}

.LandingPage_footerTagline__V5cYG {
  color: var(--color-text-muted);
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

/* Footer Links */
.LandingPage_footerLinks__9S\\+Pb {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}

@media (max-width: 768px) {
  .LandingPage_footerLinks__9S\\+Pb {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .LandingPage_footerLinks__9S\\+Pb {
    grid-template-columns: 1fr;
  }
}

.LandingPage_footerLinkGroup__vcs4v h4 {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 16px;
}

.LandingPage_footerLinkGroup__vcs4v a,
.LandingPage_footerLinkGroup__vcs4v button {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--color-text-muted);
  text-decoration: none;
  padding: 6px 0;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.15s;
  text-align: left;
}

.LandingPage_footerLinkGroup__vcs4v a:hover,
.LandingPage_footerLinkGroup__vcs4v button:hover {
  color: var(--color-text);
}

.LandingPage_footerLinkGroup__vcs4v svg {
  opacity: 0.7;
}

/* Footer Disclaimer */
.LandingPage_footerDisclaimer__72Lvy {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  padding: 24px;
  margin: 0 0 32px;
  background-color: rgba(239, 68, 68, 0.05);
  border: 1px solid rgba(239, 68, 68, 0.15);
  border-radius: 12px;
  border-top: 1px solid var(--color-border);
  padding-top: 32px;
  margin-top: 0;
}

@media (max-width: 640px) {
  .LandingPage_footerDisclaimer__72Lvy {
    flex-direction: column;
    gap: 12px;
  }
}

.LandingPage_disclaimerIcon__8\\+Dci {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(239, 68, 68, 0.1);
  border-radius: 8px;
  color: #ef4444;
}

.LandingPage_disclaimerText__Dgx8V strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 6px;
}

.LandingPage_disclaimerText__Dgx8V p {
  font-size: 13px;
  color: var(--color-text-muted);
  line-height: 1.6;
  margin: 0;
}

/* Footer Bottom */
.LandingPage_footerBottom__5MbRz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid var(--color-border);
}

@media (max-width: 640px) {
  .LandingPage_footerBottom__5MbRz {
    flex-direction: column;
    text-align: center;
  }
}

.LandingPage_footerData__MCCJg {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--color-text-muted);
  flex-wrap: wrap;
}

@media (max-width: 640px) {
  .LandingPage_footerData__MCCJg {
    justify-content: center;
  }
}

.LandingPage_footerCopyright__DuMMw {
  font-size: 12px;
  color: var(--color-text-muted);
}

/* Legal Page */
.LandingPage_focusRing__qtm1o:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-bg), 0 0 0 4px var(--color-accent);
}

.LandingPage_legalHeader__\\+cBKd {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.LandingPage_legalTitle__WtZs8 {
  font-size: 36px;
  font-weight: 700;
  color: var(--color-text-strong);
  margin: 0;
}

@media (min-width: 768px) {
  .LandingPage_legalTitle__WtZs8 {
    font-size: 42px;
  }
}

.LandingPage_legalMeta__co67d {
  font-size: 13px;
  color: var(--color-text-muted);
}

.LandingPage_legalLayout__eR2Sg {
  display: grid;
  gap: 32px;
}

@media (min-width: 1024px) {
  .LandingPage_legalLayout__eR2Sg {
    grid-template-columns: 240px 1fr;
    align-items: start;
  }
}

.LandingPage_legalSidebar__qibj- {
  display: none;
}

@media (min-width: 1024px) {
  .LandingPage_legalSidebar__qibj- {
    display: block;
  }
}

.LandingPage_legalSidebarPanel__rOmM2 {
  position: sticky;
  top: 96px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 16px;
  font-size: 12px;
  color: var(--color-text-muted);
}

.LandingPage_legalSidebarTitle__KIQL2 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--color-accent);
  margin-bottom: 12px;
}

.LandingPage_legalSidebarList__9rVTe {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.LandingPage_legalSidebarLink__1VyFH {
  color: var(--color-text-muted);
  text-decoration: none;
  transition: color 0.2s ease;
}

.LandingPage_legalSidebarLink__1VyFH:hover {
  color: var(--color-text);
}

.LandingPage_legalPanel__058RG {
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 24px;
  display: grid;
  gap: 20px;
}

.LandingPage_legalClause__Z-8Ak {
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 14px;
  padding: 20px;
  display: grid;
  gap: 12px;
}

.LandingPage_legalH2__5ovyX {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-strong);
  margin: 0;
}

.LandingPage_legalBody__H\\+495 {
  font-size: 14px;
  color: var(--color-text-muted);
  line-height: 1.7;
  margin: 0;
}

.LandingPage_legalList__890aw {
  list-style: disc;
  padding-left: 20px;
  margin: 0;
  display: grid;
  gap: 6px;
  font-size: 14px;
  color: var(--color-text-muted);
  line-height: 1.7;
}

.LandingPage_legalFooter__L4\\+JZ {
  margin-top: 32px;
  font-size: 12px;
  color: var(--color-text-muted);
}

/* CFTC Summary Value Section */
.LandingPage_cftcSummarySection__o52Ax {
  position: relative;
}

.LandingPage_cftcSummaryHeader__Sa8Za {
  max-width: 760px;
  margin: 0 auto 48px;
  text-align: center;
}

.LandingPage_cftcSummaryGrid__UukoG {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 32px;
  align-items: start;
}

.LandingPage_cftcSummaryPreview__QOmVC {
  grid-column: span 5;
  position: sticky;
  top: 120px;
  background: rgba(18, 22, 36, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 28px;
  padding: 24px;
  backdrop-filter: blur(16px);
  box-shadow: 0 20px 50px rgba(5, 8, 20, 0.35);
}

.LandingPage_cftcSummaryPreviewTop__-nLXU {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.LandingPage_cftcSummaryPill__axDUL,
.LandingPage_cftcSummaryPillMuted__40y60 {
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12px;
  color: var(--color-text);
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
}

.LandingPage_cftcSummaryPillMuted__40y60 {
  color: var(--color-text-muted);
}

.LandingPage_cftcSummaryPreviewGrid__y5CGR {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.LandingPage_cftcSummaryGhostCard__w-Uxg {
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  padding: 18px;
  font-size: 12px;
  color: var(--color-text-muted);
  min-height: 72px;
  display: flex;
  align-items: flex-end;
}

.LandingPage_cftcSummaryProofRow__hVIFl {
  border-radius: 18px;
  border: 1px dashed rgba(255, 255, 255, 0.18);
  padding: 16px;
  font-size: 12px;
  color: var(--color-text-muted);
  text-align: center;
}

.LandingPage_cftcSummarySteps__MgOcK {
  grid-column: span 7;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.LandingPage_cftcSummaryStepCard__UQsrc {
  background: rgba(18, 22, 36, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 24px;
  padding: 20px 22px;
  backdrop-filter: blur(16px);
  box-shadow: 0 16px 40px rgba(5, 8, 20, 0.3);
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.LandingPage_cftcSummaryStepCard__UQsrc:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.24);
}

.LandingPage_cftcSummaryStepCard__UQsrc h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: var(--color-text);
}

.LandingPage_cftcSummaryStepCard__UQsrc p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 14px;
  line-height: 1.6;
}

.LandingPage_cftcSummaryGuardrails__jEAuX {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 24px;
  padding: 20px 22px;
}

.LandingPage_cftcSummaryGuardrails__jEAuX h4 {
  margin: 0 0 10px;
  font-size: 16px;
  color: var(--color-text);
}

.LandingPage_cftcSummaryGuardrails__jEAuX ul {
  margin: 0;
  padding-left: 18px;
  color: var(--color-text-muted);
  font-size: 13px;
  line-height: 1.7;
}

.LandingPage_cftcSummaryCtaRow__x6K1k {
  margin-top: 8px;
}

@media (max-width: 1024px) {
  .LandingPage_cftcSummaryGrid__UukoG {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .LandingPage_cftcSummaryPreview__QOmVC,
  .LandingPage_cftcSummarySteps__MgOcK {
    grid-column: span 1;
    position: static;
  }
}

/* Detected Setups Engine */
.LandingPage_detectedSetupsSection__Sgrrr {
  padding-top: 0;
}

.LandingPage_detectedSetupsGrid__bRfVw {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-top: 32px;
}

.LandingPage_detectedSetupsCard__L7fZS {
  background: rgba(18, 22, 36, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 28px;
  padding: 24px;
  backdrop-filter: blur(16px);
  box-shadow: 0 20px 50px rgba(5, 8, 20, 0.35);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.LandingPage_detectedSetupsCard__L7fZS:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.26);
  box-shadow: 0 28px 60px rgba(5, 8, 20, 0.45);
}

.LandingPage_detectedSetupsPreview__JCkPT {
  height: 90px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.LandingPage_detectedSetupsPreviewLine__ymBT5,
.LandingPage_detectedSetupsPreviewLineWide__4VnZ7 {
  height: 2px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 999px;
}

.LandingPage_detectedSetupsPreviewLine__ymBT5 {
  width: 40%;
}

.LandingPage_detectedSetupsPreviewLineWide__4VnZ7 {
  width: 70%;
}

.LandingPage_detectedSetupsPreviewBadge__N15qE {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-accent);
  border: 1px solid rgba(141, 160, 216, 0.4);
  padding: 4px 10px;
  border-radius: 999px;
}

.LandingPage_detectedSetupsPreviewBars__yQl-B {
  display: flex;
  gap: 6px;
  align-items: flex-end;
}

.LandingPage_detectedSetupsPreviewBars__yQl-B span {
  width: 8px;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 4px;
}

.LandingPage_detectedSetupsPreviewBars__yQl-B span:nth-child(1) {
  height: 18px;
}

.LandingPage_detectedSetupsPreviewBars__yQl-B span:nth-child(2) {
  height: 32px;
}

.LandingPage_detectedSetupsPreviewBars__yQl-B span:nth-child(3) {
  height: 24px;
}

.LandingPage_detectedSetupsPreviewGrid__MnCdB {
  width: 70%;
  height: 60%;
  border-radius: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.22);
}

.LandingPage_detectedSetupsCardTitle__R1kXM {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px;
}

.LandingPage_detectedSetupsCardDesc__Z5ezD {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0 0 16px;
  line-height: 1.5;
}

.LandingPage_detectedSetupsList__S6pyo {
  margin: 0 0 16px;
  padding-left: 18px;
  color: var(--color-text);
  font-size: 13px;
  line-height: 1.6;
}

.LandingPage_detectedSetupsList__S6pyo li {
  margin-bottom: 6px;
}

.LandingPage_detectedSetupsFooter__YUsSt {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 12px;
  color: var(--color-text-muted);
}

@media (max-width: 1024px) {
  .LandingPage_detectedSetupsGrid__bRfVw {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .LandingPage_detectedSetupsGrid__bRfVw {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LandingPage.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,aAAa;EACb,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6FAA6F;EAC7F,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;wEAEsE;EACtE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA,aAAa;AACb;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,4EAA4E;EAC5E,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;EACtC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wFAAwF;EACxF,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC;;;;;;GAMC;AACH;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC;;;;;;GAMC;AACH;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kFAAkF;AACpF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;;6CAE6C;AAC7C;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,yCAAyC;EACzC,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,gCAAgC;IAChC,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,4CAA4C;EAC5C,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Main Container */\n.main {\n  min-height: 100vh;\n  background-color: var(--color-bg);\n  color: var(--color-text);\n}\n\n/* Section */\n.section {\n  padding: 80px 0;\n}\n\n.sectionInner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.textCenter {\n  text-align: center;\n}\n\n/* Section Labels & Titles */\n.sectionLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  border-radius: 9999px;\n  border: 1px solid rgba(141, 160, 216, 0.3);\n  background-color: rgba(141, 160, 216, 0.1);\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--color-accent);\n  margin-bottom: 16px;\n}\n\n.sectionTitle {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--color-text);\n  margin: 0;\n}\n\n.sectionSubtitle {\n  font-size: 18px;\n  color: var(--color-text-muted);\n  margin-top: 16px;\n}\n\n/* Separator */\n.separator {\n  height: 1px;\n  background-color: var(--color-border);\n  opacity: 0.4;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Hero Section */\n.heroSection {\n  padding-top: 120px;\n  position: relative;\n  overflow: hidden;\n}\n\n.workflowSection {\n  padding: 96px 0 72px;\n  background: var(--color-bg);\n  position: relative;\n  overflow: hidden;\n}\n\n.workflowGlow {\n  position: absolute;\n  top: -220px;\n  right: 12%;\n  width: 520px;\n  height: 520px;\n  background: var(--color-accent);\n  opacity: 0.08;\n  filter: blur(140px);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.workflowInner {\n  max-width: 1150px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  position: relative;\n  z-index: 1;\n}\n\n.workflowHeader {\n  text-align: center;\n}\n\n.workflowPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n.workflowTitle {\n  margin-top: 16px;\n  font-size: 32px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n  letter-spacing: -0.02em;\n}\n\n.workflowQuestion {\n  margin-top: 14px;\n  font-size: 18px;\n  color: var(--color-text);\n}\n\n.workflowBody {\n  margin: 16px auto 0;\n  max-width: 780px;\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--color-text-muted);\n}\n\n.workflowGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n  align-items: stretch;\n}\n\n.workflowPreviewCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 24px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  backdrop-filter: blur(18px);\n  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.35);\n}\n\n.workflowPreviewPills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.workflowPreviewPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n.workflowTileGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.workflowTile {\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  color: var(--color-text-muted);\n  font-size: 13px;\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.workflowBottomRow {\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px dashed var(--color-border);\n  background: var(--color-bg-muted);\n  text-align: center;\n  font-size: 13px;\n  color: var(--color-text-muted);\n}\n\n.workflowCardStack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.workflowCard {\n  border-radius: 24px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  padding: 22px;\n  backdrop-filter: blur(18px);\n  transition: transform 0.3s ease, border-color 0.3s ease;\n}\n\n.workflowCard:hover {\n  transform: translateY(-2px);\n  border-color: rgba(141, 160, 216, 0.4);\n}\n\n.workflowCardHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.workflowCardTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.workflowCardTagline {\n  margin-top: 6px;\n  font-size: 14px;\n  color: var(--color-text);\n}\n\n.workflowCardBody {\n  margin-top: 12px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--color-text-muted);\n}\n\n.workflowCardIcon {\n  color: var(--color-text-muted);\n}\n\n\n.workflowPreviewImages {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n  max-width: 1200px;\n  margin: 32px auto;\n}\n\n.workflowPreviewImage {\n  flex: 1;\n  max-width: 48%;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n@media (max-width: 768px) {\n  .workflowPreviewImages {\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n  }\n  \n  .workflowPreviewImage {\n    flex: none;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n  }\n}\n\n.workflowValueLine {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 500;\n  color: var(--color-text);\n}\n\n.workflowCta {\n  align-self: center;\n  padding: 14px 32px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  color: var(--color-text-strong);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s ease, border-color 0.3s ease, transform 0.3s ease;\n}\n\n.workflowCta:hover {\n  background: var(--color-bg-muted);\n  border-color: rgba(141, 160, 216, 0.4);\n  transform: translateY(-1px);\n}\n\n.workflowCta:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent), 0 0 0 4px var(--color-bg);\n}\n\n@media (min-width: 1024px) {\n  .workflowGrid {\n    grid-template-columns: 1.1fr 1fr;\n  }\n\n  .workflowPreviewCard {\n    position: sticky;\n    top: 120px;\n    align-self: flex-start;\n  }\n}\n\n@media (max-width: 640px) {\n  .workflowSection {\n    padding: 64px 0 56px;\n  }\n\n  .workflowTitle {\n    font-size: 28px;\n  }\n\n  .workflowQuestion {\n    font-size: 16px;\n  }\n\n  .workflowValueLine {\n    font-size: 18px;\n  }\n}\n\n.heroGlow {\n  position: absolute;\n  top: -300px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 600px;\n  height: 600px;\n  background: var(--color-accent);\n  opacity: 0.1;\n  filter: blur(120px);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.heroContent {\n  text-align: center;\n  position: relative;\n  z-index: 1;\n}\n\n.heroIntro {\n  margin-top: 18px;\n}\n\n.heroIntroTitle {\n  font-size: 14px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n.heroIntroSubtitle {\n  margin-top: 10px;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.heroIntroBody {\n  margin: 14px auto 0;\n  max-width: 760px;\n  font-size: 16px;\n  line-height: 1.7;\n  color: var(--color-text-muted);\n}\n\n.heroTitle {\n  font-size: 48px;\n  font-weight: 700;\n  max-width: 800px;\n  margin: 24px auto 0;\n  background: linear-gradient(90deg, var(--color-text), var(--color-accent), var(--color-text));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n@media (min-width: 768px) {\n  .heroTitle {\n    font-size: 64px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .heroTitle {\n    font-size: 72px;\n  }\n}\n\n.heroSubtitle {\n  font-size: 18px;\n  color: var(--color-text-muted);\n  max-width: 640px;\n  margin: 24px auto 0;\n}\n\n.heroCta {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 40px;\n}\n\n@media (min-width: 640px) {\n  .heroCta {\n    flex-direction: row;\n  }\n}\n\n.heroDisclaimer {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin-top: 24px;\n}\n\n.heroPreview {\n  max-width: 800px;\n  margin: 64px auto 0;\n}\n\n/* CTA Buttons */\n.ctaPrimary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 32px;\n  border-radius: 8px;\n  border: none;\n  background-color: var(--color-accent);\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.ctaPrimary:hover {\n  opacity: 0.9;\n}\n\n.ctaSecondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 32px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  background-color: transparent;\n  color: var(--color-text);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.ctaSecondary:hover {\n  background-color: var(--color-bg-muted);\n}\n\n/* Mock Chart */\n.mockChart {\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 4px;\n}\n\n.heroPreviewImage {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n\n.mockChartInner {\n  position: relative;\n  height: 320px;\n  border-radius: 12px;\n  background-color: var(--color-bg-muted);\n  overflow: hidden;\n}\n\n.mockChartGrid {\n  position: absolute;\n  inset: 0;\n  background-image: \n    linear-gradient(to right, var(--color-border) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--color-border) 1px, transparent 1px);\n  background-size: 32px 32px;\n  opacity: 0.3;\n}\n\n.mockChartBadges {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: flex;\n  gap: 8px;\n}\n\n.mockChartBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg-muted);\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n.mockChartBadgeLive {\n  composes: mockChartBadge;\n  color: var(--color-success);\n}\n\n.mockChartLines {\n  position: absolute;\n  left: 24px;\n  right: 24px;\n  bottom: 80px;\n  height: 128px;\n}\n\n.mockChartArea {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 96px;\n  background: linear-gradient(to top, rgba(141, 160, 216, 0.2), transparent);\n  border-radius: 8px;\n}\n\n.mockChartLine1 {\n  position: absolute;\n  bottom: 32px;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: var(--color-accent);\n}\n\n.mockChartLine2 {\n  position: absolute;\n  bottom: 64px;\n  left: 25%;\n  right: 25%;\n  height: 1px;\n  background-color: var(--color-success);\n}\n\n.mockChartFooter {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  right: 16px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n/* Benefits Grid */\n.benefitsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-top: 48px;\n}\n\n@media (min-width: 768px) {\n  .benefitsGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.benefitCard {\n  padding: 24px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  transition: all 0.2s;\n}\n\n.benefitCard:hover {\n  border-color: rgba(141, 160, 216, 0.5);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.benefitIcon {\n  display: inline-flex;\n  padding: 12px;\n  border-radius: 12px;\n  background-color: rgba(141, 160, 216, 0.1);\n  color: var(--color-accent);\n  margin-bottom: 16px;\n}\n\n.benefitTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 8px;\n}\n\n.benefitDesc {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n/* Services */\n.servicesGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 48px;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .servicesGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.servicesList {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.serviceItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 16px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n}\n\n.serviceIcon {\n  padding: 8px;\n  border-radius: 8px;\n  background-color: rgba(141, 160, 216, 0.1);\n  color: var(--color-accent);\n}\n\n.serviceTitle {\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.serviceDesc {\n  font-size: 14px;\n  color: var(--color-text-muted);\n}\n\n.servicesPanel {\n  padding: 24px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n}\n\n.servicesPanelBadges {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg-muted);\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n.badgeSuccess {\n  composes: badge;\n  color: var(--color-success);\n}\n\n.servicesPanelContent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.servicesPanelCard {\n  padding: 16px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n}\n\n.servicesPanelLabel {\n  font-size: 12px;\n  color: var(--color-text-muted);\n  margin-bottom: 8px;\n}\n\n.servicesPanelTags {\n  display: flex;\n  gap: 8px;\n}\n\n.servicesPanelBar {\n  margin-top: 12px;\n  height: 80px;\n  border-radius: 8px;\n  background-color: var(--color-bg);\n}\n\n.servicesPanelBarFill {\n  height: 100%;\n  width: 66%;\n  border-radius: 8px;\n  background: linear-gradient(to right, rgba(141, 160, 216, 0.3), transparent);\n}\n\n.servicesPanelHeatmap {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 4px;\n}\n\n.heatmapCell {\n  height: 32px;\n  border-radius: 4px;\n}\n\n.heatmapSuccess {\n  background-color: rgba(0, 204, 0, 0.4);\n}\n\n.heatmapWarning {\n  background-color: rgba(246, 196, 83, 0.4);\n}\n\n.heatmapAccent {\n  background-color: rgba(141, 160, 216, 0.2);\n}\n\n/* Features Grid */\n.featuresGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-top: 48px;\n}\n\n@media (min-width: 640px) {\n  .featuresGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .featuresGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.featureCard {\n  padding: 20px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  transition: background-color 0.2s;\n}\n\n.featureCard:hover {\n  background-color: var(--color-bg-panel);\n}\n\n.featureIcon {\n  display: inline-flex;\n  padding: 8px;\n  border-radius: 8px;\n  background-color: rgba(141, 160, 216, 0.1);\n  color: var(--color-accent);\n  margin-bottom: 12px;\n}\n\n.featureTitle {\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 4px;\n}\n\n.featureDesc {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n/* Process */\n.processGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n  margin-top: 48px;\n}\n\n@media (min-width: 768px) {\n  .processGrid {\n    grid-template-columns: 1fr 1.5fr;\n  }\n}\n\n.processSteps {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.processStep {\n  width: 100%;\n  padding: 16px;\n  border-radius: 12px;\n  border: none;\n  background-color: var(--color-bg-muted);\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: var(--color-text);\n}\n\n.processStep:hover {\n  background-color: var(--color-bg-panel);\n}\n\n.processStepActive {\n  background-color: var(--color-accent);\n  color: white;\n}\n\n.processStepActive:hover {\n  background-color: var(--color-accent);\n}\n\n.processStepNumber {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  opacity: 0.7;\n}\n\n.processStepTitle {\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n.processDetail {\n  padding: 32px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n}\n\n.processDetailNumber {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: var(--color-accent);\n  color: white;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.processDetailTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 8px;\n}\n\n.processDetailDesc {\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n.processDetailVisual {\n  margin-top: 24px;\n  height: 160px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--color-accent) 0%, transparent 50%);\n  opacity: 0.2;\n}\n\n/* Testimonials */\n.testimonialsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-top: 48px;\n}\n\n@media (min-width: 768px) {\n  .testimonialsGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.testimonialCard {\n  padding: 24px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n}\n\n.testimonialStars {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n\n.testimonialQuote {\n  color: var(--color-text-muted);\n  margin: 0 0 16px;\n}\n\n.testimonialAuthor {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.testimonialAvatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgba(141, 160, 216, 0.2);\n}\n\n.testimonialName {\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.testimonialRole {\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n/* Pricing */\n.pricingToggle {\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n}\n\n.pricingToggle > div {\n  display: inline-flex;\n  padding: 4px;\n  border-radius: 9999px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg-muted);\n}\n\n.toggleButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 9999px;\n  border: none;\n  background-color: transparent;\n  color: var(--color-text-muted);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.toggleButtonActive {\n  background-color: var(--color-accent);\n  color: white;\n}\n\n.toggleBadge {\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background-color: rgba(0, 204, 0, 0.2);\n  font-size: 12px;\n  color: var(--color-success);\n}\n\n.pricingGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-top: 48px;\n}\n\n@media (min-width: 768px) {\n  .pricingGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.pricingCard {\n  position: relative;\n  padding: 24px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n}\n\n.pricingCardPopular {\n  border-color: var(--color-accent);\n  box-shadow: 0 10px 40px rgba(141, 160, 216, 0.2);\n}\n\n.pricingBadge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 4px 12px;\n  border-radius: 9999px;\n  background-color: var(--color-accent);\n  color: white;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.pricingName {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 16px;\n}\n\n.pricingPrice {\n  margin-bottom: 24px;\n}\n\n.pricingAmount {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.pricingPeriod {\n  color: var(--color-text-muted);\n}\n\n.pricingButton {\n  width: 100%;\n  padding: 12px;\n  border-radius: 8px;\n  border: none;\n  background-color: var(--color-bg-muted);\n  color: var(--color-text);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.pricingButton:hover {\n  background-color: var(--color-bg);\n}\n\n.pricingButtonPopular {\n  background-color: var(--color-accent);\n  color: white;\n}\n\n.pricingButtonPopular:hover {\n  opacity: 0.9;\n  background-color: var(--color-accent);\n}\n\n.pricingFeatures {\n  list-style: none;\n  padding: 0;\n  margin: 24px 0 0;\n}\n\n.pricingFeature {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin-bottom: 12px;\n}\n\n/* Comparison */\n.comparisonTable {\n  max-width: 768px;\n  margin: 48px auto 0;\n}\n\n.comparisonHeader {\n  display: grid;\n  grid-template-columns: 1fr 100px 100px;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.comparisonUs {\n  text-align: center;\n  font-weight: 600;\n  color: var(--color-accent);\n}\n\n.comparisonOthers {\n  text-align: center;\n  font-weight: 600;\n  color: var(--color-text-muted);\n}\n\n.comparisonRow {\n  display: grid;\n  grid-template-columns: 1fr 100px 100px;\n  gap: 16px;\n  padding: 16px;\n  margin-bottom: 12px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n}\n\n.comparisonFeature {\n  font-size: 14px;\n  color: var(--color-text);\n}\n\n.comparisonCheck,\n.comparisonX {\n  display: flex;\n  justify-content: center;\n}\n\n/* FAQ */\n.faqGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 48px;\n}\n\n@media (min-width: 768px) {\n  .faqGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.faqContact {\n  margin-top: 32px;\n  padding: 24px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n}\n\n.faqContactTitle {\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.faqContactText {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 8px 0 16px;\n}\n\n.faqList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faqItem {\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.faqQuestion {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border: none;\n  background-color: transparent;\n  color: var(--color-text);\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n}\n\n.faqChevronOpen {\n  transform: rotate(90deg);\n}\n\n.faqAnswer {\n  padding: 0 16px 16px;\n  font-size: 14px;\n  color: var(--color-text-muted);\n  border-top: 1px solid var(--color-border);\n  padding-top: 12px;\n}\n\n/* CTA Section */\n.ctaSection {\n  padding-bottom: 96px;\n}\n\n.ctaCard {\n  position: relative;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.ctaCardGlow {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, rgba(141, 160, 216, 0.1), transparent, rgba(141, 160, 216, 0.1));\n  pointer-events: none;\n}\n\n.ctaCardContent {\n  position: relative;\n  padding: 48px;\n  text-align: center;\n}\n\n.ctaCardLabel {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n.ctaCardTitle {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--color-text);\n  margin: 16px 0 0;\n}\n\n@media (min-width: 768px) {\n  .ctaCardTitle {\n    font-size: 40px;\n  }\n}\n\n.ctaCardSubtitle {\n  color: var(--color-text-muted);\n  max-width: 512px;\n  margin: 16px auto 0;\n}\n\n.ctaCardButtons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 32px;\n}\n\n@media (min-width: 640px) {\n  .ctaCardButtons {\n    flex-direction: row;\n  }\n}\n\n.ctaCardDisclaimer {\n  font-size: 12px;\n  color: var(--color-text-muted);\n  margin: 24px 0 0;\n}\n\n/* Footer */\n.footer {\n  padding: 32px 0;\n  border-top: 1px solid var(--color-border);\n}\n\n/* Removed conflicting footerInner - using the one below */\n\n.footerLinks {\n  display: flex;\n  gap: 24px;\n}\n\n.footerLinks a {\n  color: var(--color-text-muted);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.footerLinks a:hover {\n  color: var(--color-text);\n}\n\n/* Optimized layout additions */\n.heroSupport {\n  font-size: 16px;\n  color: var(--color-text-muted);\n  max-width: 680px;\n  margin: 16px auto 0;\n}\n\n.heroSecondaryCta {\n  margin-top: 12px;\n}\n\n.socialProof {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px 24px 0;\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n}\n\n.socialProofItem {\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n}\n\n.navCardGrid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  margin-top: 24px;\n}\n\n.navCardGroup {\n  margin-top: 28px;\n}\n\n.navGroupLabel {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--color-text-muted);\n  margin-bottom: 10px;\n}\n\n.navCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 14px;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.navCardHighlight {\n  border-color: rgba(141, 160, 216, 0.5);\n  box-shadow: 0 0 0 1px rgba(141, 160, 216, 0.2);\n}\n\n.navCardTitle {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.navCardDesc {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n  line-height: 1.4;\n}\n\n.navCardAction {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  color: var(--color-accent);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.navCardAction:hover {\n  opacity: 0.85;\n}\n\n.bulletList {\n  list-style: none;\n  padding: 0;\n  max-width: 720px;\n  margin: 24px auto 0;\n  display: grid;\n  gap: 12px;\n  color: var(--color-text);\n}\n\n.bulletList li {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-size: 0.95rem;\n}\n\n.featureGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 32px;\n  align-items: center;\n}\n\n.featureGridReverse {\n  direction: rtl;\n}\n\n.featureGridReverse > * {\n  direction: ltr;\n}\n\n.featureList,\n.trustList {\n  list-style: none;\n  padding: 0;\n  display: grid;\n  gap: 10px;\n  margin-top: 16px;\n  color: var(--color-text);\n}\n\n.trustList li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.mockPanel {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 14px;\n  padding: 20px;\n}\n\n.mockTabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.mockTab,\n.mockTabActive {\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n}\n\n.mockTabActive {\n  color: var(--color-accent);\n  background: rgba(141, 160, 216, 0.15);\n}\n\n.mockRow {\n  margin-bottom: 16px;\n}\n\n.mockLabel {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  margin-bottom: 8px;\n}\n\n.mockLine {\n  height: 120px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, rgba(141, 160, 216, 0.2), rgba(141, 160, 216, 0.05));\n  border: 1px solid var(--color-border);\n}\n\n.mockHeatmap {\n  height: 120px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: repeating-linear-gradient(\n    90deg,\n    rgba(141, 160, 216, 0.15),\n    rgba(141, 160, 216, 0.15) 12px,\n    rgba(141, 160, 216, 0.05) 12px,\n    rgba(141, 160, 216, 0.05) 24px\n  );\n}\n\n.mockBadgeRow {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n}\n\n.mockBadge,\n.mockBadgeAccent {\n  font-size: 0.7rem;\n  padding: 4px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n}\n\n.mockBadgeAccent {\n  color: var(--color-warning);\n  border-color: rgba(246, 196, 83, 0.4);\n}\n\n.mockFootnote {\n  margin-top: 12px;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n.mockTitle {\n  font-size: 0.85rem;\n  color: var(--color-text);\n  margin-bottom: 8px;\n}\n\n.mockCandles {\n  height: 160px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: repeating-linear-gradient(\n    90deg,\n    rgba(141, 160, 216, 0.18),\n    rgba(141, 160, 216, 0.18) 8px,\n    transparent 8px,\n    transparent 16px\n  );\n}\n\n.mockOverlayRow {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  font-size: 0.7rem;\n  color: var(--color-text-muted);\n  margin-top: 10px;\n}\n\n.mockRiskBox {\n  margin-top: 12px;\n  height: 60px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: linear-gradient(90deg, rgba(0, 204, 0, 0.2), rgba(255, 107, 107, 0.2));\n}\n\n.mockRiskZone {\n  height: 100%;\n  border-radius: 12px;\n}\n\n.macroGrid {\n  display: grid;\n  gap: 24px;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  align-items: start;\n}\n\n.calloutCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  font-style: italic;\n  color: var(--color-text);\n}\n\n.confluenceCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.confluenceTitle {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.confluenceBadges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.confluenceLines {\n  display: grid;\n  gap: 6px;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.twoColCards {\n  display: grid;\n  gap: 24px;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n}\n\n.panelCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.panelCard h3 {\n  margin-top: 0;\n}\n\n.panelCard ul {\n  padding-left: 18px;\n  margin: 12px 0 0;\n  color: var(--color-text-muted);\n}\n\n.complianceCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 20px;\n  text-align: center;\n}\n\n.complianceCard ul {\n  list-style: none;\n  padding: 0;\n  margin: 16px auto;\n  display: grid;\n  gap: 10px;\n  justify-content: center;\n}\n\n.complianceCard li {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n  color: var(--color-text);\n}\n\n.complianceFooter {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n/* Trade Setups - Hero Stats */\n\n.setupsPreviewContainer {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-width: 1200px;\n  margin: 32px auto;\n}\n\n.setupsPreviewImage {\n  width: 100%;\n  max-width: 1100px;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.setupsHeroCta {\n  margin-top: 32px;\n}\n\n.setupsHeroStats {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  margin-top: 24px;\n  font-size: 14px;\n  color: var(--color-text-muted);\n}\n\n.setupsHeroStats span {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.setupsHeroStats span::before {\n  content: '✓';\n  color: var(--color-success);\n}\n\n/* Trade Setups - Benefits */\n.setupsBenefits {\n  background-color: var(--color-bg-muted);\n}\n\n.benefitsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  margin-top: 48px;\n}\n\n@media (max-width: 768px) {\n  .benefitsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.benefitCard {\n  padding: 32px 24px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  text-align: center;\n  transition: all 0.2s;\n}\n\n.benefitCard:hover {\n  border-color: rgba(141, 160, 216, 0.5);\n  transform: translateY(-4px);\n}\n\n.benefitIcon {\n  font-size: 32px;\n  margin-bottom: 16px;\n}\n\n.benefitTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 8px;\n}\n\n.benefitDesc {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Trade Setups - Setup Types Grid */\n.setupTypesGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-top: 48px;\n}\n\n@media (max-width: 1024px) {\n  .setupTypesGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .setupTypesGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.setupTypeCard {\n  padding: 20px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  text-align: center;\n  transition: all 0.2s;\n}\n\n.setupTypeCard:hover {\n  background-color: var(--color-bg-panel);\n  border-color: rgba(141, 160, 216, 0.3);\n}\n\n.setupTypeIcon {\n  font-size: 24px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.setupTypeCard h4 {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 4px;\n}\n\n.setupTypeCard p {\n  font-size: 13px;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n/* Trade Setups - Setup Card Demo */\n.setupCardDemo {\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 24px;\n  font-size: 14px;\n}\n\n.setupCardHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.setupCardDirection {\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--color-text);\n}\n\n.setupCardConfidence {\n  color: var(--color-success);\n  font-weight: 500;\n}\n\n.setupCardStatus {\n  padding: 4px 10px;\n  background-color: rgba(34, 197, 94, 0.15);\n  color: var(--color-success);\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.setupCardLevels {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 12px 0;\n  border-top: 1px solid var(--color-border);\n  border-bottom: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n}\n\n.setupCardMeta {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: var(--color-text-muted);\n  font-size: 13px;\n}\n\n.setupCardReason {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: var(--color-bg-muted);\n  border-radius: 8px;\n}\n\n.setupCardReason strong {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--color-text);\n}\n\n.setupCardReason ul {\n  margin: 0;\n  padding-left: 20px;\n  color: var(--color-text-muted);\n}\n\n.setupCardReason li {\n  margin-bottom: 4px;\n}\n\n/* Feature Description */\n.featureDesc {\n  color: var(--color-text-muted);\n  line-height: 1.6;\n  margin-bottom: 24px;\n}\n\n.featureDesc em {\n  color: var(--color-accent);\n  font-style: normal;\n}\n\n/* Overlay List */\n.overlayList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.overlayItem {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--color-text-muted);\n}\n\n/* ========================================\n   FOOTER\n   ======================================== */\n.footer {\n  background-color: var(--color-bg-panel);\n  border-top: 1px solid var(--color-border);\n  margin-top: 80px;\n}\n\n.footerInner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 64px 24px 32px;\n}\n\n/* Footer Top */\n.footerTop {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 48px;\n  padding-bottom: 40px;\n  margin-bottom: 0;\n}\n\n@media (max-width: 900px) {\n  .footerTop {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n}\n\n.footerBrand {\n  max-width: 280px;\n}\n\n.footerLogo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--color-text);\n  margin-bottom: 12px;\n}\n\n.footerLogo svg {\n  color: var(--color-accent);\n}\n\n.footerTagline {\n  color: var(--color-text-muted);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Footer Links */\n.footerLinks {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 32px;\n}\n\n@media (max-width: 768px) {\n  .footerLinks {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .footerLinks {\n    grid-template-columns: 1fr;\n  }\n}\n\n.footerLinkGroup h4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 16px;\n}\n\n.footerLinkGroup a,\n.footerLinkGroup button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--color-text-muted);\n  text-decoration: none;\n  padding: 6px 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.15s;\n  text-align: left;\n}\n\n.footerLinkGroup a:hover,\n.footerLinkGroup button:hover {\n  color: var(--color-text);\n}\n\n.footerLinkGroup svg {\n  opacity: 0.7;\n}\n\n/* Footer Disclaimer */\n.footerDisclaimer {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n  padding: 24px;\n  margin: 0 0 32px;\n  background-color: rgba(239, 68, 68, 0.05);\n  border: 1px solid rgba(239, 68, 68, 0.15);\n  border-radius: 12px;\n  border-top: 1px solid var(--color-border);\n  padding-top: 32px;\n  margin-top: 0;\n}\n\n@media (max-width: 640px) {\n  .footerDisclaimer {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n.disclaimerIcon {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(239, 68, 68, 0.1);\n  border-radius: 8px;\n  color: #ef4444;\n}\n\n.disclaimerText strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 6px;\n}\n\n.disclaimerText p {\n  font-size: 13px;\n  color: var(--color-text-muted);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Footer Bottom */\n.footerBottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding-top: 24px;\n  border-top: 1px solid var(--color-border);\n}\n\n@media (max-width: 640px) {\n  .footerBottom {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n.footerData {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n  flex-wrap: wrap;\n}\n\n@media (max-width: 640px) {\n  .footerData {\n    justify-content: center;\n  }\n}\n\n.footerCopyright {\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n/* Legal Page */\n.focusRing:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-bg), 0 0 0 4px var(--color-accent);\n}\n\n.legalHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.legalTitle {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--color-text-strong);\n  margin: 0;\n}\n\n@media (min-width: 768px) {\n  .legalTitle {\n    font-size: 42px;\n  }\n}\n\n.legalMeta {\n  font-size: 13px;\n  color: var(--color-text-muted);\n}\n\n.legalLayout {\n  display: grid;\n  gap: 32px;\n}\n\n@media (min-width: 1024px) {\n  .legalLayout {\n    grid-template-columns: 240px 1fr;\n    align-items: start;\n  }\n}\n\n.legalSidebar {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n  .legalSidebar {\n    display: block;\n  }\n}\n\n.legalSidebarPanel {\n  position: sticky;\n  top: 96px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 16px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n.legalSidebarTitle {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.15em;\n  color: var(--color-accent);\n  margin-bottom: 12px;\n}\n\n.legalSidebarList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.legalSidebarLink {\n  color: var(--color-text-muted);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.legalSidebarLink:hover {\n  color: var(--color-text);\n}\n\n.legalPanel {\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 24px;\n  display: grid;\n  gap: 20px;\n}\n\n.legalClause {\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 14px;\n  padding: 20px;\n  display: grid;\n  gap: 12px;\n}\n\n.legalH2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n  margin: 0;\n}\n\n.legalBody {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  line-height: 1.7;\n  margin: 0;\n}\n\n.legalList {\n  list-style: disc;\n  padding-left: 20px;\n  margin: 0;\n  display: grid;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--color-text-muted);\n  line-height: 1.7;\n}\n\n.legalFooter {\n  margin-top: 32px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n/* CFTC Summary Value Section */\n.cftcSummarySection {\n  position: relative;\n}\n\n.cftcSummaryHeader {\n  max-width: 760px;\n  margin: 0 auto 48px;\n  text-align: center;\n}\n\n.cftcSummaryGrid {\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n  gap: 32px;\n  align-items: start;\n}\n\n.cftcSummaryPreview {\n  grid-column: span 5;\n  position: sticky;\n  top: 120px;\n  background: rgba(18, 22, 36, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 28px;\n  padding: 24px;\n  backdrop-filter: blur(16px);\n  box-shadow: 0 20px 50px rgba(5, 8, 20, 0.35);\n}\n\n.cftcSummaryPreviewTop {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.cftcSummaryPill,\n.cftcSummaryPillMuted {\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 12px;\n  color: var(--color-text);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.cftcSummaryPillMuted {\n  color: var(--color-text-muted);\n}\n\n.cftcSummaryPreviewGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.cftcSummaryGhostCard {\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 18px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n  min-height: 72px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.cftcSummaryProofRow {\n  border-radius: 18px;\n  border: 1px dashed rgba(255, 255, 255, 0.18);\n  padding: 16px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n  text-align: center;\n}\n\n.cftcSummarySteps {\n  grid-column: span 7;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.cftcSummaryStepCard {\n  background: rgba(18, 22, 36, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 24px;\n  padding: 20px 22px;\n  backdrop-filter: blur(16px);\n  box-shadow: 0 16px 40px rgba(5, 8, 20, 0.3);\n  transition: transform 0.2s ease, border-color 0.2s ease;\n}\n\n.cftcSummaryStepCard:hover {\n  transform: translateY(-4px);\n  border-color: rgba(255, 255, 255, 0.24);\n}\n\n.cftcSummaryStepCard h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: var(--color-text);\n}\n\n.cftcSummaryStepCard p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.cftcSummaryGuardrails {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 24px;\n  padding: 20px 22px;\n}\n\n.cftcSummaryGuardrails h4 {\n  margin: 0 0 10px;\n  font-size: 16px;\n  color: var(--color-text);\n}\n\n.cftcSummaryGuardrails ul {\n  margin: 0;\n  padding-left: 18px;\n  color: var(--color-text-muted);\n  font-size: 13px;\n  line-height: 1.7;\n}\n\n.cftcSummaryCtaRow {\n  margin-top: 8px;\n}\n\n@media (max-width: 1024px) {\n  .cftcSummaryGrid {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .cftcSummaryPreview,\n  .cftcSummarySteps {\n    grid-column: span 1;\n    position: static;\n  }\n}\n\n/* Detected Setups Engine */\n.detectedSetupsSection {\n  padding-top: 0;\n}\n\n.detectedSetupsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  margin-top: 32px;\n}\n\n.detectedSetupsCard {\n  background: rgba(18, 22, 36, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 28px;\n  padding: 24px;\n  backdrop-filter: blur(16px);\n  box-shadow: 0 20px 50px rgba(5, 8, 20, 0.35);\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.detectedSetupsCard:hover {\n  transform: translateY(-4px);\n  border-color: rgba(255, 255, 255, 0.26);\n  box-shadow: 0 28px 60px rgba(5, 8, 20, 0.45);\n}\n\n.detectedSetupsPreview {\n  height: 90px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.detectedSetupsPreviewLine,\n.detectedSetupsPreviewLineWide {\n  height: 2px;\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: 999px;\n}\n\n.detectedSetupsPreviewLine {\n  width: 40%;\n}\n\n.detectedSetupsPreviewLineWide {\n  width: 70%;\n}\n\n.detectedSetupsPreviewBadge {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--color-accent);\n  border: 1px solid rgba(141, 160, 216, 0.4);\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n.detectedSetupsPreviewBars {\n  display: flex;\n  gap: 6px;\n  align-items: flex-end;\n}\n\n.detectedSetupsPreviewBars span {\n  width: 8px;\n  background: rgba(255, 255, 255, 0.35);\n  border-radius: 4px;\n}\n\n.detectedSetupsPreviewBars span:nth-child(1) {\n  height: 18px;\n}\n\n.detectedSetupsPreviewBars span:nth-child(2) {\n  height: 32px;\n}\n\n.detectedSetupsPreviewBars span:nth-child(3) {\n  height: 24px;\n}\n\n.detectedSetupsPreviewGrid {\n  width: 70%;\n  height: 60%;\n  border-radius: 12px;\n  border: 1px dashed rgba(255, 255, 255, 0.22);\n}\n\n.detectedSetupsCardTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 8px;\n}\n\n.detectedSetupsCardDesc {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 0 0 16px;\n  line-height: 1.5;\n}\n\n.detectedSetupsList {\n  margin: 0 0 16px;\n  padding-left: 18px;\n  color: var(--color-text);\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.detectedSetupsList li {\n  margin-bottom: 6px;\n}\n\n.detectedSetupsFooter {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n@media (max-width: 1024px) {\n  .detectedSetupsGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .detectedSetupsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `LandingPage_main__KrAyt`,
	"section": `LandingPage_section__7EdB3`,
	"sectionInner": `LandingPage_sectionInner__7nR4A`,
	"textCenter": `LandingPage_textCenter__63XUG`,
	"sectionLabel": `LandingPage_sectionLabel__JWI4F`,
	"sectionTitle": `LandingPage_sectionTitle__BTXaA`,
	"sectionSubtitle": `LandingPage_sectionSubtitle__1Gwu0`,
	"separator": `LandingPage_separator__zCjgL`,
	"heroSection": `LandingPage_heroSection__ZO0qF`,
	"workflowSection": `LandingPage_workflowSection__0kf+j`,
	"workflowGlow": `LandingPage_workflowGlow__UmV0-`,
	"workflowInner": `LandingPage_workflowInner__EoJhq`,
	"workflowHeader": `LandingPage_workflowHeader__KvKxc`,
	"workflowPill": `LandingPage_workflowPill__S32SR`,
	"workflowTitle": `LandingPage_workflowTitle__5E-9F`,
	"workflowQuestion": `LandingPage_workflowQuestion__gsa+D`,
	"workflowBody": `LandingPage_workflowBody__zBYNP`,
	"workflowGrid": `LandingPage_workflowGrid__cL3CM`,
	"workflowPreviewCard": `LandingPage_workflowPreviewCard__L08TU`,
	"workflowPreviewPills": `LandingPage_workflowPreviewPills__lWwAS`,
	"workflowPreviewPill": `LandingPage_workflowPreviewPill__km4Ed`,
	"workflowTileGrid": `LandingPage_workflowTileGrid__2vwyf`,
	"workflowTile": `LandingPage_workflowTile__9QWNK`,
	"workflowBottomRow": `LandingPage_workflowBottomRow__etBIq`,
	"workflowCardStack": `LandingPage_workflowCardStack__B1vUg`,
	"workflowCard": `LandingPage_workflowCard__+mt2E`,
	"workflowCardHeader": `LandingPage_workflowCardHeader__pnNpG`,
	"workflowCardTitle": `LandingPage_workflowCardTitle__fI05x`,
	"workflowCardTagline": `LandingPage_workflowCardTagline__GG84F`,
	"workflowCardBody": `LandingPage_workflowCardBody__OgZo+`,
	"workflowCardIcon": `LandingPage_workflowCardIcon__wiWGD`,
	"workflowPreviewImages": `LandingPage_workflowPreviewImages__F12wr`,
	"workflowPreviewImage": `LandingPage_workflowPreviewImage__mlwhk`,
	"workflowValueLine": `LandingPage_workflowValueLine__V1cxs`,
	"workflowCta": `LandingPage_workflowCta__LBk5T`,
	"heroGlow": `LandingPage_heroGlow__8iwyK`,
	"heroContent": `LandingPage_heroContent__VWhWs`,
	"heroIntro": `LandingPage_heroIntro__muOyO`,
	"heroIntroTitle": `LandingPage_heroIntroTitle__9UFAn`,
	"heroIntroSubtitle": `LandingPage_heroIntroSubtitle__p4k+x`,
	"heroIntroBody": `LandingPage_heroIntroBody__FmnKE`,
	"heroTitle": `LandingPage_heroTitle__gyAP8`,
	"heroSubtitle": `LandingPage_heroSubtitle__I8NWM`,
	"heroCta": `LandingPage_heroCta__TT1OT`,
	"heroDisclaimer": `LandingPage_heroDisclaimer__ixQsQ`,
	"heroPreview": `LandingPage_heroPreview__sBXk5`,
	"ctaPrimary": `LandingPage_ctaPrimary__ENXMi`,
	"ctaSecondary": `LandingPage_ctaSecondary__kZFdA`,
	"mockChart": `LandingPage_mockChart__r+kaR`,
	"heroPreviewImage": `LandingPage_heroPreviewImage__wY6+j`,
	"mockChartInner": `LandingPage_mockChartInner__4TEV5`,
	"mockChartGrid": `LandingPage_mockChartGrid__-qfZV`,
	"mockChartBadges": `LandingPage_mockChartBadges__fuQtu`,
	"mockChartBadge": `LandingPage_mockChartBadge__VEevW`,
	"mockChartBadgeLive": `LandingPage_mockChartBadgeLive__TrpaZ LandingPage_mockChartBadge__VEevW`,
	"mockChartLines": `LandingPage_mockChartLines__tZBlP`,
	"mockChartArea": `LandingPage_mockChartArea__Xnqbp`,
	"mockChartLine1": `LandingPage_mockChartLine1__dWV39`,
	"mockChartLine2": `LandingPage_mockChartLine2__5dONP`,
	"mockChartFooter": `LandingPage_mockChartFooter__93kTh`,
	"benefitsGrid": `LandingPage_benefitsGrid__HsHhG`,
	"benefitCard": `LandingPage_benefitCard__zKXRm`,
	"benefitIcon": `LandingPage_benefitIcon__MUhin`,
	"benefitTitle": `LandingPage_benefitTitle__POFUx`,
	"benefitDesc": `LandingPage_benefitDesc__uDkF7`,
	"servicesGrid": `LandingPage_servicesGrid__uP6jM`,
	"servicesList": `LandingPage_servicesList__pBzWO`,
	"serviceItem": `LandingPage_serviceItem__cqQp3`,
	"serviceIcon": `LandingPage_serviceIcon__96G3V`,
	"serviceTitle": `LandingPage_serviceTitle__8Utat`,
	"serviceDesc": `LandingPage_serviceDesc__UXWQo`,
	"servicesPanel": `LandingPage_servicesPanel__MrMNx`,
	"servicesPanelBadges": `LandingPage_servicesPanelBadges__BCEkS`,
	"badge": `LandingPage_badge__a+OTk`,
	"badgeSuccess": `LandingPage_badgeSuccess__BTMxW LandingPage_badge__a+OTk`,
	"servicesPanelContent": `LandingPage_servicesPanelContent__NOHNQ`,
	"servicesPanelCard": `LandingPage_servicesPanelCard__uToh2`,
	"servicesPanelLabel": `LandingPage_servicesPanelLabel__mcsXf`,
	"servicesPanelTags": `LandingPage_servicesPanelTags__XGEK2`,
	"servicesPanelBar": `LandingPage_servicesPanelBar__8MkI5`,
	"servicesPanelBarFill": `LandingPage_servicesPanelBarFill__wJhpt`,
	"servicesPanelHeatmap": `LandingPage_servicesPanelHeatmap__MjP4X`,
	"heatmapCell": `LandingPage_heatmapCell__+rZgF`,
	"heatmapSuccess": `LandingPage_heatmapSuccess__DPR20`,
	"heatmapWarning": `LandingPage_heatmapWarning__hb+sY`,
	"heatmapAccent": `LandingPage_heatmapAccent__OanK+`,
	"featuresGrid": `LandingPage_featuresGrid__x7864`,
	"featureCard": `LandingPage_featureCard__sEUkv`,
	"featureIcon": `LandingPage_featureIcon__YCB0K`,
	"featureTitle": `LandingPage_featureTitle__VhAB5`,
	"featureDesc": `LandingPage_featureDesc__yfNPQ`,
	"processGrid": `LandingPage_processGrid__PXMvy`,
	"processSteps": `LandingPage_processSteps__C0Jzh`,
	"processStep": `LandingPage_processStep__LpHN4`,
	"processStepActive": `LandingPage_processStepActive__KYGQW`,
	"processStepNumber": `LandingPage_processStepNumber__yq09W`,
	"processStepTitle": `LandingPage_processStepTitle__vY4l6`,
	"processDetail": `LandingPage_processDetail__90e7D`,
	"processDetailNumber": `LandingPage_processDetailNumber__lciCa`,
	"processDetailTitle": `LandingPage_processDetailTitle__lYOGW`,
	"processDetailDesc": `LandingPage_processDetailDesc__ioKqI`,
	"processDetailVisual": `LandingPage_processDetailVisual__N40Xx`,
	"testimonialsGrid": `LandingPage_testimonialsGrid__wSQrU`,
	"testimonialCard": `LandingPage_testimonialCard__L08wi`,
	"testimonialStars": `LandingPage_testimonialStars__5O6gX`,
	"testimonialQuote": `LandingPage_testimonialQuote__A3k-6`,
	"testimonialAuthor": `LandingPage_testimonialAuthor__zLi9m`,
	"testimonialAvatar": `LandingPage_testimonialAvatar__jnfWF`,
	"testimonialName": `LandingPage_testimonialName__3iZAe`,
	"testimonialRole": `LandingPage_testimonialRole__fhpHC`,
	"pricingToggle": `LandingPage_pricingToggle__ZBleh`,
	"toggleButton": `LandingPage_toggleButton__DkFrm`,
	"toggleButtonActive": `LandingPage_toggleButtonActive__Wp0PI`,
	"toggleBadge": `LandingPage_toggleBadge__nTlSI`,
	"pricingGrid": `LandingPage_pricingGrid__t+VWu`,
	"pricingCard": `LandingPage_pricingCard__p5bXf`,
	"pricingCardPopular": `LandingPage_pricingCardPopular__CZCOg`,
	"pricingBadge": `LandingPage_pricingBadge__rQfQh`,
	"pricingName": `LandingPage_pricingName__n5FiT`,
	"pricingPrice": `LandingPage_pricingPrice__ceBk4`,
	"pricingAmount": `LandingPage_pricingAmount__PooEI`,
	"pricingPeriod": `LandingPage_pricingPeriod__iuw2m`,
	"pricingButton": `LandingPage_pricingButton__PriaE`,
	"pricingButtonPopular": `LandingPage_pricingButtonPopular__a1Tpi`,
	"pricingFeatures": `LandingPage_pricingFeatures__2SZrz`,
	"pricingFeature": `LandingPage_pricingFeature__6ixvX`,
	"comparisonTable": `LandingPage_comparisonTable__FGSD1`,
	"comparisonHeader": `LandingPage_comparisonHeader__Pp20z`,
	"comparisonUs": `LandingPage_comparisonUs__ZP31z`,
	"comparisonOthers": `LandingPage_comparisonOthers__Tzs6U`,
	"comparisonRow": `LandingPage_comparisonRow__vvabe`,
	"comparisonFeature": `LandingPage_comparisonFeature__ZngBp`,
	"comparisonCheck": `LandingPage_comparisonCheck__rPltY`,
	"comparisonX": `LandingPage_comparisonX__sQWMt`,
	"faqGrid": `LandingPage_faqGrid__FfnnH`,
	"faqContact": `LandingPage_faqContact__6XtUR`,
	"faqContactTitle": `LandingPage_faqContactTitle__LPjFT`,
	"faqContactText": `LandingPage_faqContactText__dfd4t`,
	"faqList": `LandingPage_faqList__AeVTx`,
	"faqItem": `LandingPage_faqItem__VcGCV`,
	"faqQuestion": `LandingPage_faqQuestion__Y2TX7`,
	"faqChevronOpen": `LandingPage_faqChevronOpen__YxBmc`,
	"faqAnswer": `LandingPage_faqAnswer__NDNMU`,
	"ctaSection": `LandingPage_ctaSection__042ep`,
	"ctaCard": `LandingPage_ctaCard__Ktc4F`,
	"ctaCardGlow": `LandingPage_ctaCardGlow__nt2hV`,
	"ctaCardContent": `LandingPage_ctaCardContent__CAu5W`,
	"ctaCardLabel": `LandingPage_ctaCardLabel__UFR3j`,
	"ctaCardTitle": `LandingPage_ctaCardTitle__P2B59`,
	"ctaCardSubtitle": `LandingPage_ctaCardSubtitle__2LDJW`,
	"ctaCardButtons": `LandingPage_ctaCardButtons__e2jZ6`,
	"ctaCardDisclaimer": `LandingPage_ctaCardDisclaimer__8wz3A`,
	"footer": `LandingPage_footer__WdWFd`,
	"footerLinks": `LandingPage_footerLinks__9S+Pb`,
	"heroSupport": `LandingPage_heroSupport__t3IsX`,
	"heroSecondaryCta": `LandingPage_heroSecondaryCta__zhXvX`,
	"socialProof": `LandingPage_socialProof__4wAIN`,
	"socialProofItem": `LandingPage_socialProofItem__GSIev`,
	"navCardGrid": `LandingPage_navCardGrid__Frp69`,
	"navCardGroup": `LandingPage_navCardGroup__Dtpbh`,
	"navGroupLabel": `LandingPage_navGroupLabel__-eJyl`,
	"navCard": `LandingPage_navCard__Yztjk`,
	"navCardHighlight": `LandingPage_navCardHighlight__XaK7c`,
	"navCardTitle": `LandingPage_navCardTitle__l20+m`,
	"navCardDesc": `LandingPage_navCardDesc__Tu35R`,
	"navCardAction": `LandingPage_navCardAction__b+wy5`,
	"bulletList": `LandingPage_bulletList__mW+5Y`,
	"featureGrid": `LandingPage_featureGrid__ZE1RR`,
	"featureGridReverse": `LandingPage_featureGridReverse__Qtl8+`,
	"featureList": `LandingPage_featureList__Q8Sh-`,
	"trustList": `LandingPage_trustList__Ey0f5`,
	"mockPanel": `LandingPage_mockPanel__-RTbL`,
	"mockTabs": `LandingPage_mockTabs__-QIEz`,
	"mockTab": `LandingPage_mockTab__FPMyi`,
	"mockTabActive": `LandingPage_mockTabActive__TpCjm`,
	"mockRow": `LandingPage_mockRow__9qkDH`,
	"mockLabel": `LandingPage_mockLabel__AoTGl`,
	"mockLine": `LandingPage_mockLine__EmUr0`,
	"mockHeatmap": `LandingPage_mockHeatmap__89djB`,
	"mockBadgeRow": `LandingPage_mockBadgeRow__DYfZ5`,
	"mockBadge": `LandingPage_mockBadge__1BK5t`,
	"mockBadgeAccent": `LandingPage_mockBadgeAccent__82thn`,
	"mockFootnote": `LandingPage_mockFootnote__aST2p`,
	"mockTitle": `LandingPage_mockTitle__G5Tjd`,
	"mockCandles": `LandingPage_mockCandles__kG+G7`,
	"mockOverlayRow": `LandingPage_mockOverlayRow__CyljC`,
	"mockRiskBox": `LandingPage_mockRiskBox__E+pmr`,
	"mockRiskZone": `LandingPage_mockRiskZone__tUG1S`,
	"macroGrid": `LandingPage_macroGrid__Rq5d3`,
	"calloutCard": `LandingPage_calloutCard__Yo1aj`,
	"confluenceCard": `LandingPage_confluenceCard__JA3SX`,
	"confluenceTitle": `LandingPage_confluenceTitle__fxulw`,
	"confluenceBadges": `LandingPage_confluenceBadges__ZscIh`,
	"confluenceLines": `LandingPage_confluenceLines__N7Iao`,
	"twoColCards": `LandingPage_twoColCards__dmAl4`,
	"panelCard": `LandingPage_panelCard__nqlGy`,
	"complianceCard": `LandingPage_complianceCard__H6Fmk`,
	"complianceFooter": `LandingPage_complianceFooter__LY5ZB`,
	"setupsPreviewContainer": `LandingPage_setupsPreviewContainer__1U58g`,
	"setupsPreviewImage": `LandingPage_setupsPreviewImage__sCK1v`,
	"setupsHeroCta": `LandingPage_setupsHeroCta__yhpAx`,
	"setupsHeroStats": `LandingPage_setupsHeroStats__L+bSk`,
	"setupsBenefits": `LandingPage_setupsBenefits__H3oWt`,
	"setupTypesGrid": `LandingPage_setupTypesGrid__j+jcf`,
	"setupTypeCard": `LandingPage_setupTypeCard__0t503`,
	"setupTypeIcon": `LandingPage_setupTypeIcon__F1pXw`,
	"setupCardDemo": `LandingPage_setupCardDemo__2NgT+`,
	"setupCardHeader": `LandingPage_setupCardHeader__Z0K0T`,
	"setupCardDirection": `LandingPage_setupCardDirection__FQfwG`,
	"setupCardConfidence": `LandingPage_setupCardConfidence__7pFsu`,
	"setupCardStatus": `LandingPage_setupCardStatus__KdpF+`,
	"setupCardLevels": `LandingPage_setupCardLevels__0+gI5`,
	"setupCardMeta": `LandingPage_setupCardMeta__eOXWV`,
	"setupCardReason": `LandingPage_setupCardReason__ClYpg`,
	"overlayList": `LandingPage_overlayList__vES6N`,
	"overlayItem": `LandingPage_overlayItem__3pDNH`,
	"footerInner": `LandingPage_footerInner__n+pT9`,
	"footerTop": `LandingPage_footerTop__reKKL`,
	"footerBrand": `LandingPage_footerBrand__qF1Mh`,
	"footerLogo": `LandingPage_footerLogo__yjkRe`,
	"footerTagline": `LandingPage_footerTagline__V5cYG`,
	"footerLinkGroup": `LandingPage_footerLinkGroup__vcs4v`,
	"footerDisclaimer": `LandingPage_footerDisclaimer__72Lvy`,
	"disclaimerIcon": `LandingPage_disclaimerIcon__8+Dci`,
	"disclaimerText": `LandingPage_disclaimerText__Dgx8V`,
	"footerBottom": `LandingPage_footerBottom__5MbRz`,
	"footerData": `LandingPage_footerData__MCCJg`,
	"footerCopyright": `LandingPage_footerCopyright__DuMMw`,
	"focusRing": `LandingPage_focusRing__qtm1o`,
	"legalHeader": `LandingPage_legalHeader__+cBKd`,
	"legalTitle": `LandingPage_legalTitle__WtZs8`,
	"legalMeta": `LandingPage_legalMeta__co67d`,
	"legalLayout": `LandingPage_legalLayout__eR2Sg`,
	"legalSidebar": `LandingPage_legalSidebar__qibj-`,
	"legalSidebarPanel": `LandingPage_legalSidebarPanel__rOmM2`,
	"legalSidebarTitle": `LandingPage_legalSidebarTitle__KIQL2`,
	"legalSidebarList": `LandingPage_legalSidebarList__9rVTe`,
	"legalSidebarLink": `LandingPage_legalSidebarLink__1VyFH`,
	"legalPanel": `LandingPage_legalPanel__058RG`,
	"legalClause": `LandingPage_legalClause__Z-8Ak`,
	"legalH2": `LandingPage_legalH2__5ovyX`,
	"legalBody": `LandingPage_legalBody__H+495`,
	"legalList": `LandingPage_legalList__890aw`,
	"legalFooter": `LandingPage_legalFooter__L4+JZ`,
	"cftcSummarySection": `LandingPage_cftcSummarySection__o52Ax`,
	"cftcSummaryHeader": `LandingPage_cftcSummaryHeader__Sa8Za`,
	"cftcSummaryGrid": `LandingPage_cftcSummaryGrid__UukoG`,
	"cftcSummaryPreview": `LandingPage_cftcSummaryPreview__QOmVC`,
	"cftcSummaryPreviewTop": `LandingPage_cftcSummaryPreviewTop__-nLXU`,
	"cftcSummaryPill": `LandingPage_cftcSummaryPill__axDUL`,
	"cftcSummaryPillMuted": `LandingPage_cftcSummaryPillMuted__40y60`,
	"cftcSummaryPreviewGrid": `LandingPage_cftcSummaryPreviewGrid__y5CGR`,
	"cftcSummaryGhostCard": `LandingPage_cftcSummaryGhostCard__w-Uxg`,
	"cftcSummaryProofRow": `LandingPage_cftcSummaryProofRow__hVIFl`,
	"cftcSummarySteps": `LandingPage_cftcSummarySteps__MgOcK`,
	"cftcSummaryStepCard": `LandingPage_cftcSummaryStepCard__UQsrc`,
	"cftcSummaryGuardrails": `LandingPage_cftcSummaryGuardrails__jEAuX`,
	"cftcSummaryCtaRow": `LandingPage_cftcSummaryCtaRow__x6K1k`,
	"detectedSetupsSection": `LandingPage_detectedSetupsSection__Sgrrr`,
	"detectedSetupsGrid": `LandingPage_detectedSetupsGrid__bRfVw`,
	"detectedSetupsCard": `LandingPage_detectedSetupsCard__L7fZS`,
	"detectedSetupsPreview": `LandingPage_detectedSetupsPreview__JCkPT`,
	"detectedSetupsPreviewLine": `LandingPage_detectedSetupsPreviewLine__ymBT5`,
	"detectedSetupsPreviewLineWide": `LandingPage_detectedSetupsPreviewLineWide__4VnZ7`,
	"detectedSetupsPreviewBadge": `LandingPage_detectedSetupsPreviewBadge__N15qE`,
	"detectedSetupsPreviewBars": `LandingPage_detectedSetupsPreviewBars__yQl-B`,
	"detectedSetupsPreviewGrid": `LandingPage_detectedSetupsPreviewGrid__MnCdB`,
	"detectedSetupsCardTitle": `LandingPage_detectedSetupsCardTitle__R1kXM`,
	"detectedSetupsCardDesc": `LandingPage_detectedSetupsCardDesc__Z5ezD`,
	"detectedSetupsList": `LandingPage_detectedSetupsList__S6pyo`,
	"detectedSetupsFooter": `LandingPage_detectedSetupsFooter__YUsSt`
};
export default ___CSS_LOADER_EXPORT___;
